import { useContext, useEffect, useState } from 'react';
import css3 from '../../Approvals/css/approval-table.module.css';
//../css/approval-table.module.css
import {FiMoreHorizontal as MoreIcon} from 'react-icons/fi';
import {MdOutlineArrowBackIosNew as LBtn,MdOutlineArrowForwardIos as RBtn} from 'react-icons/md';
//import css4 from '../../../Approvals/css/approval-table.module.css';
import css4 from  '../../Approvals/css/approval-table.module.css'
import styled from '@emotion/styled';
interface InductionInvites {
    ApplicantId: string;
    ApplicantName: string;
    ApplicantEmail: string;
    ApplicantPhone: string;
  }

interface BatchInviteTableProps {
    data: InductionInvites[] ;
}

export const DATA_PER_PAGE = 10;

const BatchInviteTable = ({data}: BatchInviteTableProps) => {


    const [activeData,setActiveData] = useState<any>([]);
    const [pageData,setPageData] = useState<any>([]);
    const [currentPage,setCurrentPage] = useState<number>(0);
    const [pageArr,setPageArr] = useState<any>([]);
    const [showMore,setShowMore] = useState<boolean>(false);
    const [showIndex,setShowIndex] = useState<any>(null);
   

    const handlePrevous = () =>{
        if(currentPage === 0){
            if(pageArr.length > 1){
                setCurrentPage(pageArr.at(-1))
                return false;
            }
            setCurrentPage(0);
            return false;
 
        }
        setCurrentPage(currentPage-1);
    }

    const handleNext = ()=>{
        if(pageArr.length > 1){
            if(currentPage === pageArr.at(-1)){
                setCurrentPage(0);
                return false;
            }
            setCurrentPage(currentPage+1);
            return false;
        }
        setCurrentPage(0);
    }

    useEffect(()=>{
        if(data && data.length > 0){
            setActiveData(data);
            let lastPage = Math.ceil(data.length/10);
            let i = 0;
            let arr = [];
            for(i = 0;i<lastPage;i++){
                arr.push(i);
            }
            setPageArr(arr);
            setPageData(data.slice(0,DATA_PER_PAGE))
        }
    },[data])

    useEffect(()=>{
        if(activeData && activeData.length > 0){    
                let start = currentPage*DATA_PER_PAGE;
                let stop = start+DATA_PER_PAGE;
                setPageData(data.slice(start,stop));  
        }
    },[currentPage])


    const handleMore = (index:number) =>{
        if(index == showIndex){
            setShowIndex(null);
            setShowMore(false);
            return
        }
        setShowIndex(index);
        setShowMore(true);
    }


    return ( 
            <>
                <Table >   
                    <div className = {'t-head'} >
                        <span>Applicant Id</span>
                        <span>Full Name</span>
                        <span>Applicant Email</span>
                        <span>Appllciant Phone Number</span>
                    </div>
                    <Tbody>
                        {pageData && pageData.length > 0 && pageData.map((eData:InductionInvites,index:number):any =>
                            <div key={index}>
                                    <span>{eData?.ApplicantId?eData?.ApplicantId.slice(0,15):''}...</span>
                                    <span>{eData?.ApplicantName}</span>
                                    <span>{eData?.ApplicantEmail}</span>
                                    <span>{eData?.ApplicantPhone}</span>
                            </div>
                        )}
                    </Tbody>
                    <div className={css3.pagination}>
                        <div>
                            <button className={`${css3.lBtn} ${css3.btn}`} onClick={handlePrevous}><LBtn/></button>
                            {pageArr && pageArr.length > 0 && pageArr.map((ePage: number, index: number) => {

                                if(index <= 2 && currentPage <= 2) return (<span
                                    style={ ePage == currentPage ? {backgroundColor : "var(--activeP-back)", color : "var(--white-color)"} : {} } 
                                    key={ePage} 
                                    onClick={() => setCurrentPage(ePage)}
                                >
                                    {ePage + 1}
                                </span>)  

                                if(index == currentPage ) return (<span
                                    style={ ePage == currentPage ? {backgroundColor : "var(--activeP-back)", color : "var(--white-color)"} : {} } 
                                    key={ePage} 
                                    onClick={() => setCurrentPage(ePage)}
                                >
                                    {ePage + 1}
                                </span>)  

                                if(index >= pageArr.length - 3 && currentPage >= pageArr.length -3) return (<span
                                    style={ ePage == currentPage ? {backgroundColor : "var(--activeP-back)", color : "var(--white-color)"} : {} } 
                                    key={ePage} 
                                    onClick={() => setCurrentPage(ePage)}
                                >
                                    {ePage + 1}
                                </span>)  

                                if(index == pageArr.length-1) return (
                                <>
                                    <>...</>
                                    <span 
                                    style={ ePage == currentPage ? {backgroundColor : "var(--activeP-back)", color : "var(--white-color)"} : {} } 
                                    key={ePage} 
                                    onClick={() => setCurrentPage(ePage)}
                                    >
                                        {ePage + 1}
                                    </span>
                                </>
                                )  

                                if(index == 0 ) return (
                                <>
                                    <span 
                                    style={ ePage == currentPage ? {backgroundColor : "var(--activeP-back)", color : "var(--white-color)"} : {} } 
                                    key={ePage} 
                                    onClick={() => setCurrentPage(ePage)}
                                    >
                                        {ePage + 1}
                                    </span>
                                    <>...</>
                                </>)  

                                })} 
                            <button className={`${css3.rBtn} ${css3.btn}`} onClick={handleNext}><RBtn/></button>
                        </div>
                    </div>
                </Table>
               
            </>
    )
}

const Table = styled.div`
        padding-block-start: 10px;
        & > .table-div{
            display:flex;
            flex-direction:column;
            gap:5px;
            margin-top:10px;
        }
        & > .table-div > div{
            width:100%;
        }
        & .t-head{
            display:grid;
            grid-template-columns:repeat(4,1fr);
            background-color:#E0FAEE;
            padding:15px 10px;
        }
`
const Tbody = styled.div`
        display: flex;
        gap:8px;
        flex-direction: column;
        border-top:2px solid #E2E4E9;
        border-bottom:2px solid #E2E4E9;
        min-height: 250px;

        & > div{
            border-left:2px solid #fff;
            display:grid;
            grid-template-columns:repeat(4,1fr);
            padding:10px 7px;
        }
        & > div:hover{
            border-left-color:#293856;
        }
`

export default BatchInviteTable;


